import style from './style.module.scss';
import {useNavigate} from "react-router-dom";
import newsData from '../../../assets/data/news.json';
import {INews} from "../../../entities/news";
import {NewsCard} from "../../news/news-card";

export const News = () => {
    const navigate = useNavigate();

    return (
        <div className={style.news_section}>

            <h2 className={style.section_title}>Aktuelle <span>Neuigkeiten</span></h2>

            <div className={style.post_container}>

                <div className={style.timeline}>
                    {
                        newsData.filter((n: INews) => n.active).length > 0 ? (
                            newsData
                                .filter(n => n.active)
                                .slice(0, 3)
                                .map((news, index) => (
                                    <NewsCard
                                        key={index}
                                        image={news.image}
                                        title={news.title}
                                        description={news.description}
                                        date={news.date}
                                        category={news.category}
                                    />
                                ))
                        ) : (
                            <div className={style.error_msg}>Keine Neuigkeiten</div>
                        )
                    }
                </div>
            </div>

            <button className={style.more_info_button} onClick={() => navigate("/neuigkeiten")}>
                <span>Mehr Neuigkeiten...</span>
            </button>
        </div>
    );
}